/* eslint-disable no-unused-expressions,no-param-reassign,react/jsx-props-no-spreading */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router";
import { v4 as uuid } from "uuid";
import {
  Input,
  DatePicker,
  Button,
  Row,
  Col,
  Table,
  Collapse,
  Pagination,
  Space,
  Checkbox,
  Select,
  Form,
} from "antd";
import { isEmpty } from "lodash";
import pick from "lodash/pick";
import "./AccountDetalization.less";
import "../../styles/filters-form.less";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import axios from "axios";
import { displayFormat, toDisplayFormatWithTime } from "../../lib/utils/formatDate";
import TablePageSelect from "../TablePageSelect/TablePageSelect";
import AuthService from "../../services/AuthService";
import { formatDate } from "../../lib/utils";
import { exportToXLS } from "../../store/slices/xlsExport";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { getRejectedTrafficsDetailSearchXLS } from "../../lib/routes/rejected-traffic";
import ReprocessModal from "./ReprocessModal";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_ACCOUNT_TRANSACTION_REPROCESS } from "../../lib/const/permissions";
import MultipleSelect from "../common/MultipleSelect";
import { getAccountVersionsRoute } from "../../lib/routes/accounts";
import ToggleColumns from "../ToggleableVersionsTable/ToggleColumns";
import versionsTableUtils from "../../lib/utils/versionsTableUtils";
import { limitText } from "../../lib/utils/limitText";

const dateFormat = displayFormat;
const { RangePicker } = DatePicker;
const { Option } = Select;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const buttonLayout = {
  wrapperCol: { span: 24 },
};

const AccountDetalization = ({
  fetchRejectedTrafficDetailSearchContentLoading,
  fetchRejectedTrafficDetailSearchContent,
  handleSetPagination,
  handleSearchRejectsTraffic,
  resetSearchRejectsTraffic,
  disabledFields,
  initialFormSearchValues,
  runReprocessLoading,
  getSearchValues,
  onChecked,
  onSelect,
  form,
  pagination,
}) => {
  const [filtersCollapseState, setFiltersCollapsState] = useState("unfolded");
  const [firstVersionFromDate, setFirstVersionFromDate] = useState(undefined);
  const { accountId } = useParams();
  const [isLoading, setIsLoading] = useState(rtkRequestStatusCodes.idle);
  const [isReprocessModalVisible, setIsReprocessModalVisible] = useState(false);
  const { Panel } = Collapse;
  const exportStatus = useSelector((state) => state.xlsExport.exportToXLSLoading);
  const { trafficStatus, trafficStatusLoading, serviceUsageDocumentType } = useSelector(
    (state) => state.rtkDictionaries
  );
  const { serviceUsageProcessingType, serviceUsageProcessingTypeLoading } = useSelector(
    (state) => state.dicts
  );
  const dispatch = useDispatch();

  const buttonRef = useRef(null);

  useEffect(() => {
    axios.get(getAccountVersionsRoute(accountId)).then(({ data }) => {
      data.sort((a, b) => (moment(a.fromDate).isBefore(b.fromDate) ? -1 : 1));
      setFirstVersionFromDate(data[0].fromDate);
    });
  }, []);

  const getTableHeight = () => (filtersCollapseState === "unfolded" ? `${62}vh` : `${65}vh`);

  const toggleFiltersCollapseState = () => {
    const newState = filtersCollapseState === "unfolded" ? "folded" : "unfolded";
    setFiltersCollapsState(newState);
  };

  const getPanelHeader = () =>
    filtersCollapseState === "unfolded" ? (
      ""
    ) : (
      <div className="bulk__panel_header">Показать фильтры</div>
    );

  const renderFilters = () => (
    <div>
      <Row>
        <Col span={11}>
          <Form.Item label="ID транзакции" name="includeDocumentIds">
            <Input placeholder="Введите значение" allowClear />
          </Form.Item>
        </Col>
        <Col span={11} offset={1}>
          <Form.Item
            label="Дата документа"
            name="rangeDate"
            className="form-item-required__hidden-error__mb0"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <RangePicker
              style={{ width: "100%" }}
              format={dateFormat}
              allowClear={false}
              disabledDate={(date) =>
                date.isBefore(firstVersionFromDate, "day") || moment(date).isAfter(moment(), "day")
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={11}>
          <Form.Item label="Статус" name="includeServiceUsageStatusIds">
            <MultipleSelect
              allValues={trafficStatus?.map(({ id }) => id) || []}
              onChange={onSelect}
              placeholder="Выбрать"
              showArrow
              disabled={disabledFields.includeServiceUsageStatusIds}
              maxTagCount={3}
            >
              {checkIsLoaded(trafficStatusLoading) &&
                trafficStatus &&
                [...trafficStatus]
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((item) => (
                    <Option key={item.id} value={item?.id}>
                      {item?.name}
                    </Option>
                  ))}
            </MultipleSelect>
          </Form.Item>
        </Col>
        <Col span={11} offset={1}>
          <Form.Item label="Только отсев" name="onlyFailServiceUsageStatusIds">
            <Checkbox
              checked={disabledFields.includeServiceUsageStatusIds}
              onChange={(e) => onChecked(e.target.checked)}
              disabled={disabledFields.onlyFailServiceUsageStatusIds}
            >
              <label className="filters-label filters-label_small">Только отсев</label>
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={11}>
          <Form.Item label="Тип обработки трафика" name="includeProcessingTypes">
            <MultipleSelect
              allValues={serviceUsageProcessingType?.map(({ id }) => id) || []}
              onChange={onSelect}
              placeholder="Выбрать"
              showArrow
              disabled={disabledFields.includeServiceUsageStatusIds}
              maxTagCount={1}
              allowClear
            >
              {checkIsLoaded(serviceUsageProcessingTypeLoading) &&
                serviceUsageProcessingType.map((item) => (
                  <Option key={item.id} value={item?.id}>
                    {item?.name}
                  </Option>
                ))}
            </MultipleSelect>
          </Form.Item>
        </Col>
        <Col span={11}>
          <Form.Item {...buttonLayout} style={{ textAlign: "right", marginBottom: 0 }}>
            <Button onClick={resetSearchRejectsTraffic}>Сброс параметров</Button>
            <Button
              htmlType="submit"
              loading={checkIsLoading(fetchRejectedTrafficDetailSearchContentLoading)}
              type="primary"
            >
              Применить
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );

  const pageSizeOptions = {
    20: 20,
    50: 50,
    100: 100,
    1000: 1000,
  };

  const columnsWidths = {
    senderAccountName: "140px",
    recipientAccountName: "140px",
    recipientGln: "140px",
    senderGln: "140px",
    senderSubscriberId: "85px",
    recipientSubscriberId: "85px",
    senderSubscriber: "140px",
    recipientSubscriber: "140px",
    serviceUsageStatusId: "85px",
    eventDate: "85px",
    documentDate: "85px",
    documentName: "140px",
    documentId: "85px",
    serviceType: "140px",
    signed: "85px",
    documentSize: "85px",
    documentType: "170px",
    senderTags: "85px",
    recipientTags: "85px",
    processingType: "85px",
    senderPrice: "140px",
    recipientPrice: "140px",
  };

  const [columns, setColumns] = useState([
    {
      title: "Аккаунт отправителя",
      dataIndex: "senderAccountName",
      key: "senderAccountName",
      hidden: false,
      width: columnsWidths.senderAccountName,
    },
    {
      title: "Аккаунт получателя",
      dataIndex: "recipientAccountName",
      key: "recipientAccountName",
      hidden: false,
      width: columnsWidths.recipientAccountName,
    },
    {
      title: "Атрибут отправителя",
      dataIndex: "senderGln",
      key: "senderGln",
      hidden: true,
      width: columnsWidths.senderGln,
    },
    {
      title: "Атрибут получателя",
      dataIndex: "recipientGln",
      key: "recipientGln",
      hidden: true,
      width: columnsWidths.recipientGln,
    },
    {
      title: "ID отправителя",
      dataIndex: "senderSubscriberId",
      key: "senderSubscriberId",
      hidden: true,
      width: columnsWidths.senderSubscriberId,
    },
    {
      title: "ID получателя",
      dataIndex: "recipientSubscriberId",
      key: "recipientSubscriberId",
      hidden: true,
      width: columnsWidths.recipientSubscriberId,
    },
    {
      title: "Тех. ID отправителя",
      dataIndex: "senderSubscriber",
      key: "senderSubscriber",
      hidden: false,
      width: columnsWidths.senderSubscriber,
    },
    {
      title: "Тех. ID получателя",
      dataIndex: "recipientSubscriber",
      key: "recipientSubscriber",
      hidden: false,
      width: columnsWidths.recipientSubscriber,
    },
    {
      title: "Статус отправителя",
      dataIndex: "senderUsageStatusId",
      key: "senderUsageStatusId",
      hidden: false,
      width: columnsWidths.serviceUsageStatusId,
    },
    {
      title: "Статус получателя",
      dataIndex: "recipientUsageStatusId",
      key: "recipientUsageStatusId",
      hidden: false,
      width: columnsWidths.serviceUsageStatusId,
    },
    {
      title: "Дата обработки",
      dataIndex: "eventDate",
      key: "eventDate",
      hidden: false,
      width: columnsWidths.eventDate,
    },
    {
      title: "Дата документа",
      dataIndex: "documentDate",
      key: "documentDate",
      hidden: false,
      width: columnsWidths.documentDate,
    },
    {
      title: "ID транзакции",
      dataIndex: "documentId",
      key: "documentId",
      hidden: false,
      width: columnsWidths.documentId,
    },
    {
      title: "Имя документа",
      dataIndex: "documentName",
      key: "documentName",
      hidden: true,
      width: columnsWidths.documentName,
    },
    {
      title: "Продукт",
      dataIndex: "serviceType",
      key: "serviceType",
      hidden: true,
      width: columnsWidths.serviceType,
    },
    {
      title: "Тип транзакции",
      dataIndex: "documentType",
      key: "documentType",
      hidden: false,
      render: (documentType) => <span title={documentType}>{limitText(documentType, 30)}</span>,
      width: columnsWidths.documentType,
    },
    {
      title: "Объем",
      dataIndex: "documentSize",
      key: "documentSize",
      hidden: false,
      width: columnsWidths.documentSize,
    },
    {
      title: "Стоимость для отправителя",
      dataIndex: "senderPrice",
      key: "senderPrice",
      hidden: true,
      width: columnsWidths.senderPrice,
    },
    {
      title: "Стоимость для получателя",
      dataIndex: "recipientPrice",
      key: "recipientPrice",
      hidden: true,
      width: columnsWidths.recipientPrice,
    },
    {
      title: "Подписан",
      dataIndex: "signed",
      key: "signed",
      hidden: true,
      width: columnsWidths.signed,
    },
    {
      title: "Тег отправителя",
      dataIndex: "senderTags",
      key: "senderTags",
      hidden: true,
      width: columnsWidths.senderTags,
    },
    {
      title: "Тег получателя",
      dataIndex: "recipientTags",
      key: "recipientTags",
      hidden: true,
      width: columnsWidths.recipientTags,
    },
    {
      title: "Тип обработки",
      dataIndex: "processingType",
      key: "processingType",
      hidden: true,
      width: columnsWidths.processingType,
    },
  ]);

  const filterColumns = [...columns].filter((item) => !item.hidden);

  let tableData;

  if (filterColumns && filterColumns.length) {
    tableData =
      checkIsLoaded(fetchRejectedTrafficDetailSearchContentLoading) &&
      fetchRejectedTrafficDetailSearchContent &&
      fetchRejectedTrafficDetailSearchContent?.content.map((detail) => ({
        key: uuid(),
        recipientAccountName: detail?.recipientAccountName,
        senderAccountName: detail?.senderAccountName,
        senderGln: detail?.senderGln,
        recipientGln: detail?.recipientGln,
        senderSubscriberId: detail?.senderSubscriberId,
        recipientSubscriberId: detail?.recipientSubscriberId,
        senderSubscriber: detail?.senderSubscriber,
        recipientSubscriber: detail?.recipientSubscriber,
        senderUsageStatusId:
          checkIsLoaded(trafficStatusLoading) &&
          trafficStatus &&
          trafficStatus.find((item) => item.id === detail?.senderUsageStatusId)?.name,
        recipientUsageStatusId:
          checkIsLoaded(trafficStatusLoading) &&
          trafficStatus &&
          trafficStatus.find((item) => item.id === detail?.recipientUsageStatusId)?.name,
        eventDate: detail?.eventDate ? toDisplayFormatWithTime(detail?.eventDate) : "",
        documentDate: detail?.documentDate ? toDisplayFormatWithTime(detail?.documentDate) : "",
        documentName: detail?.documentName,
        documentId: detail?.documentId,
        serviceType: detail?.serviceType,
        signed: detail?.signed ? "Да" : "Нет",
        documentSize: detail?.documentSize,
        documentType: serviceUsageDocumentType.find(({ alias }) => alias === detail?.documentType)
          ?.name,
        senderTags: detail?.senderTags.map((item) => item),
        recipientTags: detail?.recipientTags.map((item) => item),
        processingType: versionsTableUtils.geDicValueById(
          serviceUsageProcessingType,
          detail?.processingType
        )?.name,
        senderPrice: detail?.senderPrice,
        recipientPrice: detail?.recipientPrice,
      }));
  }

  const columnKeyList = useMemo(() => filterColumns.map(({ key }) => key), [filterColumns]);

  const xlsExportHeaders = useMemo(() => {
    const headerList = [
      {
        name: "senderAccountName",
        title: "Аккаунт отправителя",
        type: "String",
      },
      {
        name: "recipientAccountName",
        title: "Аккаунт получателя",
        type: "String",
      },
      {
        name: "senderGln",
        title: "Аттрибут отправителя",
        type: "String",
      },
      {
        name: "recipientGln",
        title: "Аттрибут получателя",
        type: "String",
      },
      {
        name: "senderSubscriberId",
        title: "ID отправителя",
        type: "String",
      },
      {
        name: "recipientSubscriberId",
        title: "ID получателя",
        type: "String",
      },
      {
        name: "senderSubscriber",
        title: "Тех. ID отправителя",
        type: "String",
      },
      {
        name: "recipientSubscriber",
        title: "Тех. ID получателя",
        type: "String",
      },
      { name: "senderUsageStatusId", title: "Статус отправителя", type: "String" },
      { name: "recipientUsageStatusId", title: "Статус получателя", type: "String" },
      { name: "eventDate", title: "Дата обработки", type: "LocalDateTime" },
      { name: "documentDate", title: "Дата документа", type: "LocalDateTime" },
      { name: "documentId", title: "ID транзакции", type: "String" },
      { name: "documentName", title: "Имя документа", type: "String" },
      { name: "serviceType", title: "Продукт", type: "String" },
      { name: "documentType", title: "Тип транзакции", type: "String" },
      { name: "documentSize", title: "Объем", type: "String" },

      { name: "senderPrice", title: "Стоимость для отправителя", type: "String" },
      { name: "recipientPrice", title: "Стоимость для получателя", type: "String" },

      { name: "signed", title: "Подписан", type: "String" },
      { name: "senderTags", title: "Тег отправителя", type: "String" },
      { name: "recipientTags", title: "Тег получателя", type: "String" },
      { name: "processingType", title: "Тип обработки", type: "String" },
    ];
    return headerList.filter(({ name }) => columnKeyList.includes(name));
  }, [columnKeyList]);

  const renderFooter = () => {
    const handleExport = async () => {
      setIsLoading(rtkRequestStatusCodes.pending);
      try {
        const searchValues = getSearchValues();
        const url = getRejectedTrafficsDetailSearchXLS(searchValues);
        const { data } = await axios(url);
        const { display_name: author } = jwtDecode(AuthService.getCurrentUser());
        const exportedData = {
          fileName: `Детализация аккаунта_${formatDate.toDisplayFormat(moment())}`,
          title: "Выгрузка данных в формате xls",
          description: "Выгрузка данных",
          periodFrom: moment(searchValues.fromDate).format("YYYY-MM-DD"),
          periodTo: moment(searchValues.toDate).format("YYYY-MM-DD"),
          author,
          header: xlsExportHeaders,
          data: await data.map((detail) => {
            let senderTrStatus;
            let recipientTrStatus;
            if (checkIsLoaded(trafficStatusLoading) && trafficStatus) {
              const checkSender = trafficStatus.find((item2) => item2.id === detail.senderUsageStatusId);
              if (checkSender) {
                senderTrStatus = checkSender.name;
              } else {
                senderTrStatus = "";
              }

              const checkRecipient = trafficStatus.find((item2) => item2.id === detail.recipientUsageStatusId);
              if (checkRecipient) {
                recipientTrStatus = checkRecipient.name;
              } else {
                recipientTrStatus = "";
              }

            }

            return pick(
              {
                senderAccountName: detail?.senderAccountName,
                recipientAccountName: detail?.recipientAccountName,
                senderGln: detail?.senderGln,
                recipientGln: detail?.recipientGln,
                senderSubscriberId: detail?.senderSubscriberId,
                recipientSubscriberId: detail?.recipientSubscriberId,
                senderSubscriber: detail?.senderSubscriber,
                recipientSubscriber: detail?.recipientSubscriber,
                senderUsageStatusId: senderTrStatus,
                recipientUsageStatusId: recipientTrStatus,
                eventDate: detail?.eventDate ? toDisplayFormatWithTime(detail?.eventDate) : "",
                documentDate: detail?.documentDate
                  ? toDisplayFormatWithTime(detail?.documentDate)
                  : "",
                documentId: detail?.documentId,
                documentName: detail?.documentName,
                serviceType: detail?.serviceType,
                documentType: serviceUsageDocumentType.find(
                  ({ alias }) => alias === detail?.documentType
                )?.name,
                documentSize: detail?.documentSize,
                senderPrice: detail?.senderPrice,
                recipientPrice: detail?.recipientPrice,
                signed: detail?.signed ? "Да" : "Нет",
                senderTags: detail?.senderTags.map((item) => item).join(", "),
                recipientTags: detail?.recipientTags.map((item) => item).join(", "),
                processingType: detail?.processingType,
              },
              columnKeyList
            );
          }),
        };
        await dispatch(exportToXLS(exportedData));
        setIsLoading(rtkRequestStatusCodes.fulfilled);
      } catch (e) {
        setIsLoading(rtkRequestStatusCodes.rejected);
      }
    };

    return (
      <Space className="buttons-container">
        <Button
          type="primary"
          disabled={
            fetchRejectedTrafficDetailSearchContent?.content?.length === 0 || !filterColumns.length
          }
          loading={checkIsLoading(isLoading) || checkIsLoading(exportStatus)}
          onClick={handleExport}
        >
          Выгрузить в XLS
        </Button>
      </Space>
    );
  };

  const getPaginationTotal = () => {
    if (isEmpty(fetchRejectedTrafficDetailSearchContent)) {
      return 0;
    }
    const total =
      (fetchRejectedTrafficDetailSearchContent.number + 1) *
      fetchRejectedTrafficDetailSearchContent.size;
    return fetchRejectedTrafficDetailSearchContent.last ? total : total + 1;
  };

  useEffect(() => {
    buttonRef.current?.blur();
  }, [isReprocessModalVisible]);

  // const itemRender = (_, type, originalElement) => {
  //   // eslint-disable-next-line dot-notation
  //   const key = Number(originalElement["_owner"].key);
  //   if (type === "prev" || type === "next" || key === 1 || key === pagination.page) {
  //     return originalElement;
  //   }
  //   if (key === 2 && key !== pagination.page && key !== pagination.page + 1) {
  //     return <span style={{ color: "#00000040" }}>•••</span>;
  //   }
  //   if (key !== pagination.page && key === pagination.page + 1) {
  //     return <span style={{ color: "#00000040" }}>•••</span>;
  //   }
  //   return <></>;
  // };
  return (
    <div className="account-detalization">
      <ReprocessModal
        isReprocessModalVisible={isReprocessModalVisible}
        setIsReprocessModalVisible={setIsReprocessModalVisible}
        firstVersionFromDate={firstVersionFromDate}
      />
      <Form
        form={form}
        labelAlign="left"
        initialValues={initialFormSearchValues}
        {...layout}
        onFinish={handleSearchRejectsTraffic}
      >
        <div className="reject-form">
          <Row justify="space-between" align="middle">
            <Col>
              <h1>Детализация</h1>
            </Col>
            <Col>
              {hasAccess(MENU_ACCOUNT_TRANSACTION_REPROCESS) && (
                <Button
                  type="primary"
                  loading={runReprocessLoading}
                  onClick={() => setIsReprocessModalVisible(true)}
                  ref={buttonRef}
                >
                  Перетарификация
                </Button>
              )}
            </Col>
          </Row>
          <Collapse
            defaultActiveKey="1"
            onChange={toggleFiltersCollapseState}
            expandIconPosition="right"
            className="filter-collapse account-detalization__filter"
          >
            <Panel header={getPanelHeader()} key="1">
              {renderFilters()}
            </Panel>
          </Collapse>
        </div>

        <Row justify="end" align="middle" className=" account-detalization__pagination">
          <Col span={12}>
            <Row justify="center">
              <Pagination
                disabled={checkIsLoading(fetchRejectedTrafficDetailSearchContentLoading)}
                onChange={(e) => handleSetPagination({ page: e })}
                current={
                  checkIsLoaded(fetchRejectedTrafficDetailSearchContentLoading) &&
                  fetchRejectedTrafficDetailSearchContent?.number + 1
                }
                total={getPaginationTotal()}
                // itemRender={itemRender}
                pageSize={pagination.size}
                hideOnSinglePage
                size="small"
                showSizeChanger={false}
              />
            </Row>
          </Col>
          <Col span={6} style={{ paddingRight: "5px" }}>
            <Row justify="end" align="middle" wrap={false}>
              <Col style={{ marginRight: "15px" }}>
                <TablePageSelect
                  disabled={checkIsLoading(fetchRejectedTrafficDetailSearchContentLoading)}
                  onChange={(e) => handleSetPagination({ size: e, page: 1 })}
                  value={pagination.size}
                  pageSizeOptions={pageSizeOptions}
                />
              </Col>
              <ToggleColumns
                tableName="account-detalization-table"
                columns={columns}
                setColumns={setColumns}
              />
            </Row>
          </Col>
        </Row>
      </Form>
      <Table
        size="small"
        columns={filterColumns}
        loading={checkIsLoading(fetchRejectedTrafficDetailSearchContentLoading)}
        className="rejected-traffic-detail-table"
        dataSource={tableData}
        pagination={false}
        scroll={{ y: getTableHeight(), x: true }}
      />
      {renderFooter()}
    </div>
  );
};

export default AccountDetalization;
